// src/pages/production/PlaceholderTab.tsx
//
// Stub for Production sections deferred to Phase 2. Renders a centered card
// explaining what the section will do so a user clicking around understands
// where the feature is in the roadmap.

import { Construction } from 'lucide-react';

interface PlaceholderTabProps {
  title: string;
  description: string;
}

export default function PlaceholderTab({ title, description }: PlaceholderTabProps) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="max-w-md text-center p-8 rounded-2xl bg-slate-800/30 border border-slate-700/40">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-slate-700/40 flex items-center justify-center mb-4">
          <Construction size={28} className="text-slate-400" />
        </div>
        <h2 className="text-xl font-semibold text-white mb-2">{title}</h2>
        <p className="text-sm text-slate-400 leading-relaxed">{description}</p>
        <div className="mt-4 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-300 text-xs">
          Coming in Phase 2
        </div>
      </div>
    </div>
  );
}
